import { IApplicationState, IPixelEvents, processPixels } from '@spinwise/spinwise-core';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function useProcessPixels(posthog) {
  const dispatch = useDispatch();
  const pixels = useSelector((state: IApplicationState) => state.accountReducer.info?.pixels);
  const id = useSelector((state: IApplicationState) => state.accountReducer.info?.id);
  const geoSignature = useSelector((state: IApplicationState) => state.globalReducer.geo?.signature);
  const processedEids = useRef(new Set<string>());

  const handlePixelEvents = async (pixelEvents: IPixelEvents[]) => {
    const eids = pixelEvents.map(event => event.eid);
    // Optimistic mark as processed to avoid race condition from polling
    eids.forEach(eid => processedEids.current.add(eid));

    const response = await processPixels({ eids })(dispatch);
    if (!response.success) {
      eids.forEach(eid => processedEids.current.delete(eid));
      return;
    }
    pixelEvents.forEach(pixelEvent => {
      window.dataLayer.push({
        USER_ID: id,
        BATCH: geoSignature,
        AMOUNT: pixelEvent.amount,
        CURRENCY: pixelEvent.currency,
        PAYMENT_METHOD: pixelEvent.fromCurrencyName,
        // @ts-expect-error outdated interface
        ...(pixelEvent.data ?? {}),
      });
      window.dataLayer.push({ event: pixelEvent.event });
      posthog?.capture(pixelEvent.event);
    });
  };

  useEffect(() => {
    if (!pixels || pixels.length === 0) return;
    if (!window.dataLayer) return;
    if (document.hidden) return;

    const newPixelEvents = pixels.flatMap(pixel => pixel.events).filter(event => !processedEids.current.has(event.eid)); // avoid re-processing same twice
    if (newPixelEvents.length === 0) return;

    handlePixelEvents(newPixelEvents);
  }, [pixels]);
}
